import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import {useTranslation} from "react-i18next";
import Modal from '@mui/material/Modal';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {COMM_OK} from './WsR2.js';

let n_load = 0;

function LoadSplash(props) {
	const { endLoading } = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const [state, setState] = useState('');
	const [err, setErr] = useState('');

	const [info, setInfo] = useState(null);

	useEffect(() => {
		load_info();
		n_load = 0;
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (info !== null) {
			gStorage.srv.info = info;
			check_species();
		}
		// eslint-disable-next-line
	}, [info]);

	/* ------------------------------------------------------------------ */

	function load_info() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'info',
			op: 'get'
		};

		setState(t('splash.info'));
		gStorage.conn.ws.send(msg, handle_info);
	}

	function handle_info(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load info comm error ' + status + '!');
			alert('Load info comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'get') {
			if (msg.result === 'OK') {
//  				console.log('Info get: ', msg.data);
				setInfo(msg.data);
			} else {
				setErr('Load info failed ' + msg.data.desc);
			}
		} else {
			setErr('Info: invalid operation ' + msg.op + '!');
		}
	}

	/* ------------------------------------------------------------------ */

	function check_species() {
		setState(t('splash.taxons'));

// 		console.log('checkspec', props.speclist, info.tax_time);
		if (gStorage.lists.speclist.last_upd !== info.tax_time) {
			load_speclist();
		} else {
			check_city();
		}
	}

	function load_speclist() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'elist'
		};

// 		console.log('load_speclist');
		gStorage.conn.ws.send(msg, handle_species);
	}

	function handle_species(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load species comm error ' + status + '!');
			alert('Load species comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'elist') {
			if (msg.result === 'OK') {
				let _speclist = {
					last_upd: info.tax_time,
					list: msg.data.taxelist
				}

				window.localStorage.setItem('speclist', JSON.stringify(_speclist));
				n_load++;

 				check_city();
			} else {
				setErr('Load species failed ' + msg.data.desc);
			}
		} else {
			setErr('Species: invalid operation ' + msg.op + '!');
		}
	}

	/* ------------------------------------------------------------------ */

	function check_city() {
		setState(t('splash.city'));

		if (gStorage.lists.citylist.last_upd !== info.geo_time) {
			load_citylist();
		} else {
			check_reg();
		}
	}

	function load_citylist() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'geo',
			op: 'list',
			data: {
				type: 'city'
			}
		};

// 		console.log('load_citylist');
		gStorage.conn.ws.send(msg, handle_city);
	}

	function handle_city(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load geolocation comm error ' + status + '!');
			alert('Load geolocation comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'list' && msg.data.type === 'city') {
			if (msg.result === 'OK') {
				let _citylist = {
					last_upd: info.geo_time,
					list: msg.data.geolist
				}

				window.localStorage.setItem('citylist', JSON.stringify(_citylist));
				n_load++;

				check_reg();
			} else {
				setErr('Load geolocation failed ' + msg.data.desc);
			}
		} else {
			setErr('Geolocation: invalid operation ' + msg.op + '!');
		}
	}

	/* ------------------------------------------------------------------ */

	function check_reg() {
		setState(t('splash.regular'));

		if (gStorage.lists.reglist.last_upd !== info.regular_time) {
			load_reglist();
		} else {
			load_users();
		}
	}

	function load_reglist() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'reg',
			op: 'list'
		};

// 		console.log('load_reglist');
		gStorage.conn.ws.send(msg, handle_reg);
	}

	function handle_reg(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load regular locations comm error ' + status + '!');
			alert('Load regular locations comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'list') {
			if (msg.result === 'OK') {
				let _reglist = {
					last_upd: info.regular_time,
					list: msg.data.reglist
				}

				window.localStorage.setItem('reglist', JSON.stringify(_reglist));
				n_load++;

 				load_users();
			} else {
				setErr('Load regular locations failed ' + msg.data.desc);
			}
		} else {
			setErr('Regular locations: invalid operation ' + msg.op + '!');
		}
	}

	/* ------------------------------------------------------------------ */

	function load_users() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'user',
			op: 'list'
		};

// 		console.log('load_users');
		gStorage.conn.ws.send(msg, handle_users);
	}

	function handle_users(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load user list comm error ' + status + '!');
			alert('Load user list comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'list') {
			if (msg.result === 'OK') {
				let _userlist = {
					last_upd: info.user_time,
					list: msg.data.userlist
				}

// 				console.log('_userlist', _userlist);
				gStorage.lists.setUserList(_userlist);
				load_trips();
			} else {
				setErr('Load user list failed ' + msg.data.desc);
			}
		} else {
			setErr('User list: invalid operation ' + msg.op + '!');
		}
	}

	/* ------------------------------------------------------------------ */

	function load_trips() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'trip',
			op: 'list'
		};

// 		console.log('load_trips');
		gStorage.conn.ws.send(msg, handle_trips);
	}

	function handle_trips(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load trip list comm error ' + status + '!');
			alert('Load trip list comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'list') {
			if (msg.result === 'OK') {
				let _triplist = {
					last_upd: info.trip_time,
					list: msg.data.triplist ? msg.data.triplist : [],
				}

// 				console.log('_triplist', _triplist);

				gStorage.lists.setTripList(_triplist);
				load_dst();
			} else {
				setErr('Load trip list failed ' + msg.data.desc);
			}
		} else {
			setErr('Trip list: invalid operation ' + msg.op + '!');
		}
	}

	function load_dst() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'reg',
			op: 'dst_list'
		};

// 		console.log('load_dst');
		gStorage.conn.ws.send(msg, handle_dst);
	}

	function handle_dst(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load destination list comm error ' + status + '!');
			alert('Load destination list comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'dst_list') {
			if (msg.result === 'OK') {
				let dstlist = msg.data.regdst_list;

// 				console.log('dst_list', msg.data);

				dstlist.unshift({id: 0, city: '-', addr: '', lat_obs: 0, long_obs: 0});

				gStorage.lists.setDstList(dstlist);

				if (gStorage.lists.assolist.last_upd !== info.asso_time) {
					load_asso();
				} else {
					load_loc();
				}
			} else {
				setErr('Load destination list failed ' + msg.data.desc);
			}
		} else {
			setErr('Destination list: invalid operation ' + msg.op + '!');
		}
	}

	function load_asso() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'asso',
			op: 'list'
		};

// 		console.log('load_asso');
		gStorage.conn.ws.send(msg, handle_asso);
	}

	function handle_asso(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load association list comm error ' + status + '!');
			alert('Load association list comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'list') {
			if (msg.result === 'OK') {
				let assolist = {
					last_upd: info.asso_time,
					list: msg.data.assolist ? msg.data.assolist : [],
				}

				window.localStorage.setItem('assolist', JSON.stringify(assolist));

				n_load++;
				load_loc();
			} else {
				setErr('Load association list failed ' + msg.data.desc);
			}
		} else {
			setErr('Association list: invalid operation ' + msg.op + '!');
		}
	}

	function load_loc() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'location',
			op: 'statlist'
		};

		gStorage.conn.ws.send(msg, handle_loc);
	}

	function handle_loc(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load location list comm error ' + status + '!');
			alert('Load location list comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'statlist') {
			if (msg.result === 'OK') {
				let loclist = {
					last_upd: 0,
					list: msg.data.locationstatlist,
				}

// 				console.log('handle_loc', msg);

				gStorage.lists.setLocList(loclist);
				n_load++;

				if (gStorage.lists.countrylist.last_upd !== info.country_time) {
					load_countries();
				} else {
					endLoading();
				}

			} else {
				setErr('Load location list failed ' + msg.data.desc);
			}
		} else {
			setErr('Location list: invalid operation ' + msg.op + '!');
		}
	}

	function load_countries() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'geo',
			op: 'list',
			data: {
				type: 'country'
			}
		};

// 		console.log('load_countries');
		gStorage.conn.ws.send(msg, handle_country);
	}

	function handle_country(status, msg) {
		if (status !== COMM_OK) {
			setErr('Load country list comm error ' + status + '!');
			alert('Load country list comm error ' + status + '!');
			endLoading(n_load);
			return -1;
		}

		if (msg.op === 'list' && msg.data.type === 'country') {
			if (msg.result === 'OK') {
				let countrylist = {
					last_upd: info.country_time,
					list: msg.data.geolist,
				}

// 				console.log('handle_country', countrylist);

				window.localStorage.setItem('countrylist', JSON.stringify(countrylist));
				endLoading(n_load);
			} else {
				setErr('Load countrylist failed ' + msg.data.desc);
			}
		} else {
			setErr('Country list: invalid operation ' + msg.op + '!');
		}
	}

	/* ------------------------------------------------------------------ */

	return (
		<Modal open={/*gStorage.splash.loading*/Boolean(err)} onClose={endLoading}>
			<div>
				<Typography variant='h6' align='center'>
					{t('splash.loading') + ' ' + state + '...'}
				</Typography>
				<Typography variant='h6' align='center' color='error'>
					{err}
				</Typography>
			</div>
		</Modal>
	);
}

export default LoadSplash;

